import React,{ createContext, useState,useCallback, useMemo, useContext, } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from './AuthContext';
import { useDropzone} from 'react-dropzone';
import Swal from 'sweetalert2';

const DataDescriptionContext = createContext();

export default DataDescriptionContext;


const baseStyle = {
  display: 'flex',
  flexDirection:'column',
  alignItems:'center',
  padding:'20px',
  borderwidth:3,
  borderRadius:3,
  borderColor:'#eeeeee',
  borderStyle:'dashed',
  backgroundColor:'#fafafa',
  color:'#bdbdbd',
  transition:'border .3s ease-in-out'
};

const activeStyle = {
  borderColor:'#2196f3'
};

const acceptStyle={
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


export  const DataDescriptionProvider = (props) => {
  const Swal = require('sweetalert2');
  const navigate = useNavigate();
  let {authTokens, logoutUser} = useContext(AuthContext);
  const [selectedFile, setSelectedFile] = useState();
  const [isSelected, setIsSelected] = useState(false);
  const [responseData, setResponseData] = useState(()=>localStorage.getItem('rawdata')?JSON.parse(localStorage.getItem('rawdata')):null);
  const [loading, setLoading] = useState(false);

  
  const handleSubmit = () =>{
    if(isSelected===true){
      // alert("File is ready to upload....");
      Swal.fire({
        title: 'Success!',
        text:'File is ready to upload.',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
      getDescriptionData();
    }
    else{
      // alert("Upload a File....")
      Swal.fire({
        title:'Error!',
        text:'First Upload file that should either excel or csv.',
        icon: 'error',
        confirmButtonText:'Ok'
      })
    }
  }

  const cancelUpload = () =>{
    setSelectedFile(null);
    setIsSelected(false);
  };

  const onDrop = useCallback(acceptedFiles => {
    console.log(acceptedFiles);
    setSelectedFile(acceptedFiles[0]);
    console.log(selectedFile)
    setIsSelected(true);
  },[]);
  //react-hooks/exhaustive-deps

  const {getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject} = useDropzone({onDrop, 
    accept:'excel/xlsx, excel/csv'});
  
    const style = useMemo(()=> ({
      ...baseStyle,
      ...(isDragActive ? activeStyle:{}),
      ...(isDragAccept ? acceptStyle:{}),
      ...(isDragReject ? rejectStyle:{})
    }),[
      isDragAccept,
      isDragReject,
      isDragActive
    ]);

  let getDescriptionData = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    console.log("ready to upload..",formData);
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/get_description_data/`, {
      method: "POST",
      headers: {
        // 'Content-Type':'multipart/form-data',
        'Authorization':'Bearer ' + String(authTokens.access)
      },
      body: formData,
    });
    const data = await response.json()
    setLoading(false);
    if(response.status === 200){
      // console.log('WE GOT response from backed');
      Swal.fire({
        title:'Success!',
        text:'Successfully Retrive Dataset.',
        icon: 'success',
        confirmButtonText:'Ok'
      })
      setResponseData(data);
      localStorage.setItem('rawdata', JSON.stringify(data));
      navigate('/reviewdata');

    }
    else if(response.status === 401){
      console.log("Logout from system");
      // alert("You are not autherized for this action.!!!!");
      Swal.fire({
        title:'Error!',
        text:'You are not autherized for this action.',
        icon: 'error',
        confirmButtonText:'Ok'
      })
      logoutUser();
    }
    else{
      // alert("Something Wrong!!!!");
      Swal.fire({
        title:'Error!',
        text:'Something Wrong!!!',
        icon: 'error',
        confirmButtonText:'Ok'
      })
      navigate('/workarea');
    }
  };

  let contextData = {
    getDescriptionData:getDescriptionData,
    selectedFile:selectedFile,
    isSelected:isSelected,
    handleSubmit:handleSubmit,
    cancelUpload:cancelUpload,
    getRootProps:getRootProps,
    getInputProps:getInputProps,
    style:style,
    responseData:responseData,
    loading:loading
  };

  return (
    <DataDescriptionContext.Provider
      value={contextData}
    >{props.children}</DataDescriptionContext.Provider>
  );
};
